import { Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import encStorage from "public/privateCloud/encrypted-storage-clusters.jpg";

type DescCompProps = {
  description: string[];
};

const DescComp = (props: DescCompProps) => {
  const TextVariant = useTextVariants();
  const { description } = props;
  return (
    <Stack spacing={4}>
      {description.map((desc, index) => (
        <Text key={index} variant={TextVariant} color="text.100">
          {desc}
        </Text>
      ))}
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  heading: "Encrypted Storage Clusters - Distributed storage systems ",
  description: (
    <DescComp
      description={[
        "Encrypted Storage Clusters within OneMind’s architecture offer secure, distributed storage with encryption baked in—both at rest and in transit. By leveraging enterprise-grade encryption protocols across all nodes, we ensure data remains fully protected, even in the event of hardware compromise or unauthorized access attempts.",
        "This design goes beyond traditional storage by combining high availability with built-in confidentiality. Whether you're handling sensitive workloads, regulatory compliance, or mission-critical data, OneMind’s encrypted clusters provide the trust and resilience your infrastructure demands—fully managed, fully virtual, and always secure.",
      ]}
    />
  ),
  points: [
    "End-to-end encryption for data at rest & in transit",
    "Fault-tolerant architecture for high availability ",
    " Scalable, enterprise-grade cloud storage ",
  ],
  image: encStorage,
  imageHeight: "380px",
};
